import React from 'react'
import NumberFormat from 'react-number-format'
class PaginationDetail extends React.Component {
  state = {
    loading: false,
  }
  render() {
    const { data } = this.props
    return (
      <div style={{ marginTop: 7, marginBottom: 7, fontSize: 12 }}>
        {data && data.total > 0 ? (
          <React.Fragment>
              <NumberFormat
                value={data.total ? data.total : 0}
                displayType={'text'}
                style={{
                  fontSize: 15,
                  backgroundColor: "#dfdfdf",
                  color: "#222222",
                  padding:3,
                  borderRadius: 25,
                  minWidth: 25,
                  display: 'inline-block',
                  textAlign: "center"
                }}
                thousandSeparator={true}
              />{' '}
              รายการ หน้า {data.current}/ {data.pageCount} แสดงหน้าละ{' '}
              {data.perPage}
          </React.Fragment>
        ) : (
          ''
        )}{' '}
      </div>
    )
  }
}
export default PaginationDetail
